import React from 'react';
import TransactionOtp from './TransactionOtp';
import CancelTransactionButton from '../CancelTransactionButton';
import Text from '../../components/uiElem/Text';
import t from 'babel-plugin-yate/macro';
import {Block} from '../../components/uiElem';

function TransactionStep3(props) {
  const {data, patchHandler} = props;

  return (
    <>
      <div className="lg:flex -ml-10">
        <div className="lg:w-full pl-10">
          <div className="mb-4 lg:w-2/3 m-auto">
            <Block
              heading={t`Autorizeaza tranzactie`}
              descriptionClassName="jupiter">
              <div className="py-8 p-4">
                <div className="mb-8">
                  <Text ui="neptune">
                    {t`Validati numarul de telefon declarat in contractul de credit`}
                  </Text>
                </div>

                <TransactionOtp
                  transaction={data}
                  handleAction={patchHandler}
                />
              </div>
            </Block>
          </div>
        </div>
      </div>

      <div className="py-6 text-right flex justify-between">
        <div className="mr-4">
          <CancelTransactionButton uuid={data.uuid} />
        </div>
      </div>
    </>
  );
}

export default TransactionStep3;
